module.exports = __webpack_public_path__ + "img/IT0000122257446.57fff600.png";